// ADR-0088 §Ingest follow-up. Per-item evidence-requirement indicator for
// the carga-masiva preview list — five values, driven from the shared
// core-engine enum (never a hand-copied literal union, so a future sixth
// value fails loudly here instead of silently rendering nothing).
//
// Never color-only (WCAG SC 1.4.1): every state carries visible text, and
// the photo/audio states additionally carry an icon. Uses a promoted
// version of the PWA's --coverage-pending-* tokens (apps/web-svelte/src
// /lib/styles/facility.css) rather than the severity ramp — this is a
// checklist-configuration signal, not a finding severity, and mixing the
// two ramps would make severity chips and evidence chips visually
// indistinguishable in the same table.

import { evidenceRequirementSchema, type EvidenceRequirement } from "@bitacorapro/core-engine";
import { Icon } from "./icons";

const LABELS: Record<EvidenceRequirement, string> = {
  none: "Sin requisito",
  photo: "Foto",
  audio: "Nota de voz",
  photo_and_audio: "Foto y nota de voz",
  photo_or_audio: "Foto o nota de voz",
};

export function EvidenceRequirementPill({
  evidenceRequirement,
}: {
  evidenceRequirement: EvidenceRequirement;
}) {
  // Defensive parse rather than a bare cast — this renders server data.
  const requirement = evidenceRequirementSchema.safeParse(evidenceRequirement).success
    ? evidenceRequirement
    : "none";

  if (requirement === "none") {
    // fitness-allow: evidence-predicate-single-implementation
    return <span className="cell-meta">{LABELS.none}</span>;
  }

  const wantsPhoto = requirement === "photo" || requirement.startsWith("photo_"); // fitness-allow: evidence-predicate-single-implementation
  const wantsAudio = requirement === "audio" || requirement.endsWith("_audio"); // fitness-allow: evidence-predicate-single-implementation

  return (
    <span className="st-pill st-pill--pending-evidence">
      {wantsPhoto && <Icon.Photo s={12} />}
      {wantsAudio && <Icon.Mic s={12} />}
      {LABELS[requirement]}
    </span>
  );
}
